
(function(){
  function bezierPoint(t,p0,p1,p2,p3){
    const cX=3*(p1.x-p0.x), bX=3*(p2.x-p1.x)-cX, aX=p3.x-p0.x-cX-bX;
    const cY=3*(p1.y-p0.y), bY=3*(p2.y-p1.y)-cY, aY=p3.y-p0.y-cY-bY;
    return { x:aX*t*t*t + bX*t*t + cX*t + p0.x, y:aY*t*t*t + bY*t*t + cY*t + p0.y };
  }

  class FlyToCart extends HTMLElement{
    connectedCallback(){ this._animate(); }

    _animate(){
      var source = this.source || (this.getAttribute('source') ? document.querySelector(this.getAttribute('source')) : null);
      var destination = this.destination || (this.getAttribute('destination') ? document.querySelector(this.getAttribute('destination')) : null);
      if(!source || !destination){ this.remove(); return; }

      var size = parseInt(this.getAttribute('size')||'64',10);
      var duration = parseInt(this.getAttribute('duration')||'600',10);
      this.style.setProperty('--size', size+'px');

      var src = source.getBoundingClientRect();
      var dst = destination.getBoundingClientRect();

      var off = {x:size/2, y:size/2};
      var start = { x: src.left + src.width/2 - off.x, y: src.top + src.height/2 - off.y };
      var end   = { x: dst.left + dst.width/2 - off.x, y: dst.top + dst.height/2 - off.y };

      var c1 = { x:start.x,   y:start.y - 200 };
      var c2 = { x:end.x-300, y:end.y - 100 };

      this.style.setProperty('--x', start.x+'px');
      this.style.setProperty('--y', start.y+'px');
      this.style.setProperty('--scale','1');
      this.style.opacity='1';

      var startTime=null, self=this;
      function tick(now){
        if(!startTime) startTime=now;
        var t=Math.min((now-startTime)/duration,1);
        var p=bezierPoint(t,start,c1,c2,end);
        self.style.setProperty('--x', p.x+'px');
        self.style.setProperty('--y', p.y+'px');
        self.style.setProperty('--scale', (1 - t*0.5)+'');
        if(t<1){ requestAnimationFrame(tick); }
        else { self.style.opacity='0'; setTimeout(function(){ self.remove(); },180); }
      }
      requestAnimationFrame(tick);
    }
  }

  if(!customElements.get('fly-to-cart')) customElements.define('fly-to-cart', FlyToCart);

  // Public helper
  window.flyToCart = function(opts){
    // alert('fly cart trigger');
    opts = opts || {};
    var source = opts.source;
    var destination = opts.destination ||
      document.querySelector('#cart-icon-bubble, .header__icon--cart, .header-actions__cart-icon, a[href="/cart"]');
    var image = opts.image;
    var size = opts.size || 64;
    var duration = opts.duration || 600;
    if(!source || !destination) return Promise.resolve();

    var el = document.createElement('fly-to-cart');
    if(image) el.style.setProperty('background-image','url("'+image+'")');
    el.source = source;              // simple property assignment, no class field needed
    el.destination = destination;
    el.setAttribute('size', size);
    el.setAttribute('duration', duration);
    document.body.appendChild(el);

    return new Promise(function(resolve){ setTimeout(resolve, duration+250); });
  };

  // optional preloader
  window.preloadImage = function(url){ if(!url) return; var i=new Image(); i.decoding='async'; i.src=url; };
})();






if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        if(this.submitButton.dataset.image){
            window.flyToCart({
              source: this.submitButton,
              destination: document.querySelector('#cart-icon-bubble'),
              image: this.submitButton.dataset.image,
              size: 40,
              duration: 1100
            });
        }


        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        // this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              // quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            // this.submitButton.classList.remove('loading');

            // console.log("this.submitButton.dataset.image"+this.submitButton.dataset.image);
            


            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
             this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
